import type { IntlShape } from 'react-intl';

import { BulkActionType } from '~/enums/BulkActionType';

export const actionTypeTitle = (
  actionType: BulkActionType,
  intl: IntlShape,
) => {
  switch (actionType) {
    case 'restore':
      return intl.formatMessage({
        id: 'BulkActionLimits.restoring',
        defaultMessage: 'Restoring',
        description: 'Title for restore bulk action',
      });
    case 'delete':
      return intl.formatMessage({
        id: 'BulkActionLimits.deleting',
        defaultMessage: 'Deleting',
        description: 'Title for delete bulk action',
      });
    case 'permanentlyDelete':
      return intl.formatMessage({
        id: 'BulkActionLimits.permanentlyDeleting',
        defaultMessage: 'Permanently Deleting',
        description: 'Title for permanently delete bulk action',
      });
    case 'edit-clauses':
    case 'edit':
      return intl.formatMessage({
        id: 'BulkActionLimits.editing',
        defaultMessage: 'Editing',
        description: 'Title for edit bulk action',
      });
    case 'move':
      return intl.formatMessage({
        id: 'BulkActionLimits.moving',
        defaultMessage: 'Moving',
        description: 'Title for move bulk action',
      });
    case 'copy':
      return intl.formatMessage({
        id: 'BulkActionLimits.copying',
        defaultMessage: 'Copying',
        description: 'Title for copy bulk action',
      });
    case 'export':
      return intl.formatMessage({
        id: 'BulkActionLimits.exporting',
        defaultMessage: 'Exporting',
        description: 'Title for export bulk action',
      });
  }
};

export const actionTypeContent = (
  actionType: BulkActionType,
  intl: IntlShape,
) => {
  switch (actionType) {
    case 'restore':
      return intl.formatMessage({
        id: 'BulkActionLimits.restored',
        defaultMessage: 'restored',
        description: 'Past tense action content for restore',
      });
    case 'delete':
      return intl.formatMessage({
        id: 'BulkActionLimits.deleted',
        defaultMessage: 'deleted',
        description: 'Past tense action content for delete',
      });
    case 'permanentlyDelete':
      return intl.formatMessage({
        id: 'BulkActionLimits.permanentlyDeleted',
        defaultMessage: 'permanently deleted',
        description: 'Past tense action content for permanently delete',
      });
    case 'edit-clauses':
    case 'edit':
      return intl.formatMessage({
        id: 'BulkActionLimits.edited',
        defaultMessage: 'edited',
        description: 'Past tense action content for edit',
      });
    case 'move':
      return intl.formatMessage({
        id: 'BulkActionLimits.moved',
        defaultMessage: 'moved',
        description: 'Past tense action content for move',
      });
    case 'export':
      return intl.formatMessage({
        id: 'BulkActionLimits.exported',
        defaultMessage: 'exported',
        description: 'Past tense action content for export',
      });
    case 'copy':
      return intl.formatMessage({
        id: 'BulkActionLimits.copied',
        defaultMessage: 'copied',
        description: 'Past tense action content for copy',
      });
  }
};
